<template>
  <div class="xc-page">
    <div class="xc-page-main">
      <!--步骤条-->
      <xc-step :step-value="stepValue"></xc-step>
      <div class="xc-row xc-s-flex">
        <!--上传-->
        <div
          class="xc-card"
          v-if="currentStep==0"
        >
          <div class="xc-card-content">
            <form
              name="upload"
              class="xc-form"
              data-vv-scope="upload"
            >
              <div class="xc-info">
                <div class="xc-info-title">1、选择导入门店</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <xc-form-item
                      label="门店："
                      required
                      :error="errors.first('storeId','upload')"
                    >
                      <select
                        name="storeId"
                        class="xc-select"
                        :class="{'xc-input-disabled':channel}"
                        :disabled="channel"
                        v-model="storeId"
                        v-validate="'required'"
                        data-vv-as="门店"
                      >
                        <option value="">请选择</option>
                        <template v-if="stores.length">
                          <option
                            v-for="(item,index) in stores"
                            :key="index"
                            :value="item.storeId"
                            :id="item.storeId"
                          >{{item.storeName}}</option>
                        </template>
                      </select>
                    </xc-form-item>
                  </div>
                </div>
              </div>
              <div class="xc-info">
                <div class="xc-info-title">2、选择设备数据模板</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <xc-form-item>
                      <div class="xc-btn-group">
                        <button
                          type="button"
                          class="xc-btn xc-btn-download"
                          @click="download($event)"
                        >下载模板</button>
                      </div>
                    </xc-form-item>
                  </div>
                </div>
              </div>
              <div class="xc-info">
                <div class="xc-info-title">3、上传文件</div>
                <div class="xc-info-content">
                  <div class="xc-form-inline">
                    <xc-form-item>
                      <xc-upload
                        :fileList.sync="files"
                        :multiple="false"
                        type="0"
                        :url="uploadUrl"
                        dataName="url"
                      />
                    </xc-form-item>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--浏览-->
        <div
          class="xc-card"
          v-if="currentStep==1"
        >
          <div class="xc-card-content">
            <div class="xc-info">
              <div class="xc-info-content">
                <div class="xc-info-row">
                  <div class="xc-info-item">共{{list.length}}条数据</div>
                  <div class="xc-info-item">所属门店：{{storeName}}</div>
                  <div class="xc-info-item">日期：{{dateTime}}</div>
                  <div class="xc-info-item">经办人：{{userName}}</div>
                </div>
                <div class="xc-info-row">

                </div>
              </div>
            </div>
            <div class="xc-row-scroll">
              <table class="xc-table">
                <thead>
                  <th>编号</th>
                  <th>MAC地址</th>
                  <th>设备型号</th>
                  <th>设备类型</th>
                  <th>设备尺寸</th>
                  <th>设备分辨率</th>
                  <th>楼栋</th>
                  <th>单元</th>
                  <th>楼层</th>
                  <th>具体位置</th>
                  <th>设备名称</th>
                </thead>
                <tbody>
                  <template v-if="list && list.length">
                    <tr
                      v-for="(item,index) in list"
                      :key="index"
                    >
                      <td>{{index}}</td>
                      <td>{{item.deviceMac}}</td>
                      <td>{{item.model}}</td>
                      <td>{{item.type}}</td>
                      <td>{{item.screeSize}}</td>
                      <td>{{item.resolvingPower}}</td>
                      <td>{{item.building}}</td>
                      <td>{{item.unit}}</td>
                      <td>{{item.floor}}</td>
                      <td>{{item.position}}</td>
                      <td>{{item.deviceName}}</td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td
                        colspan="20"
                        class="xc-s-tac"
                      >暂无数据</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!--导入完成-->
        <div
          class="xc-card complete"
          v-if="currentStep==2"
        >
          <div class="result success">
            <img src="data:image/png;base64,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" />
            <div class="tips">导入成功</div>
            <div class="xc-info">
              <div class="xc-info-content">
                <div class="xc-info-row">
                  共{{list.length}}条数据，成功导入{{list.length}}条
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--导入失败-->
        <div
          class="xc-card complete"
          v-if="currentStep==3"
        >
          <div class="result fail">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAMAAADUivDaAAAASFBMVEUAAAD/aFz/aFz/a2L/aFz/aFz/aV3/bF//aF3/aV3/aFz/aV3/aV3/al3/aF3/aVz/a1//amr/bW3/bV7/aFz/////8O//uLIg29a6AAAAFHRSTlMA4/oczZqFJ+3s2qiUjFhQQwwHNus9mr4AAAFeSURBVFjDrZgJcsIwDEUleYGsJCDC/W/a1tPWE4gg9s87wBtHUizJZOLG2HluRBr2XRwdFTKFVp9ow0S7cZF1E477znIKoiYSTvSJeRB9iwwzveXC+hG+kM211130VzOMXnfinRFH1t3wZlRvZy3gfNs4g2EwHS/ncKyFsHvKhddi/DovvVbQrypKLR7L8lCLSzbMbBru35gOzrU+qMXyo1jUYvjPp6jFPaEW8pfZoLUKDZRwUq8QlxRR6xUak4IRBaebVhGFTimYiCIFtMUULZFTTKGORlQxUkQVkTpU0ZFHFZ4YVTA1qKIhQRVyhAL/kCPCiSf1iNLCCzz/ZmVNIDPmn72sFWVcvnKKGmKmTRcfREjXL8SUm0Al/NuKAOKqIdaEU9yqLdckNayHg4rSkhM+ohwzKOHjGj404qMrPkDjYzy+TOArDb5Y4esdvmTiqy6+cONr//GPD/gTyBfjQAhQEC5WTwAAAABJRU5ErkJggg==" />
            <div class="tips">导入失败</div>
            <div class="xc-info">
              <div class="xc-info-content">
                <div class="xc-info-row">
                  <!--共total条数据，成功导入success条，导入失败fail条-->
                </div>
                <div class="xc-info-row">
                  导入失败可能的原因有：系统中已存在该设备编码
                </div>
                <div class="xc-info-row">
                  请按下述要求检查修改后，重新上传
                </div>
                <div class="xc-info-row" v-if="fail">
                  <div class="xc-btn-group">
                    <a
                      class="xc-btn xc-btn-download"
                      :href="fail"
                    >下载失败数据</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 固低栏 -->
    <div class="xc-page-footer">
      <div class="xc-btn-group">
        <!-- <div class="xc-btn xc-btn-default" @click.prevent="cancle" v-if="currentStep==0">返回</div> -->
        <div class="xc-btn xc-btn-default" @click="close" v-if="currentStep==0">返回</div>
        <div
          class="xc-btn xc-btn-default"
          @click.prevent="preStep"
          v-if="currentStep==1"
        >上一步</div>
        <div
          class="xc-btn xc-btn-primary"
          @click.prevent="nextStep(0)"
          v-if="currentStep==0"
        >下一步</div>
        <div
          class="xc-btn xc-btn-primary"
          @click.prevent="nextStep(1)"
          v-if="currentStep==1"
        >下一步</div>
        <div
          class="xc-btn xc-btn-primary"
          @click.prevent="finish"
          v-if="currentStep==2"
        >完成</div>
        <div
          class="xc-btn xc-btn-primary"
          @click.prevent="reUpload"
          v-if="currentStep==3"
        >重新上传</div>
      </div>
    </div>
  </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer"
import "@/utils/date-format"
import { downloadExcel, uploadExcelDevice, uploadExcelDeviceSure } from "@/api/device-import"
import { getStore, getDepartment, addStore, editStore } from "@/api/store"
import userInfo from '@/api/user-info'
import "@/libs/vee-validate"
export default {
  name: "DeviceImport",
  data() {
    return {
      adminPath: this.$config.adminPath,
      currentStep: 0,
      stores: [],  //门店列表
      files: [],   //上传数据
      storeId: this.$route.query.storeId || "", //门店ID
      storeName: "",
      dateTime: "",
      userName: "",
      channel: this.$route.query.channel, //来源
      list: [],        //上传文件解析表
      fail: "",    //上传失败文件路径
      stepValue: [{
        text: "上传导入文件",
        active: true,
      },
      {
        text: "导入文件浏览",
      },
      {
        text: "导入完成",
      }
      ],
      uploadUrl: '/uploadfile'
    }
  },
  created() {
      var _this = this;
    //获取门店列表
    getStore({
      pageNum: 1,
      pageSize: 0,
    }).then(function (success) {
      let enableArr = [];
      success.data.list.forEach((ban,index) =>{
        if(ban.status == 0){
          enableArr.push(ban);
        }
      })
      _this.stores = enableArr;
    }).catch(function (error) {
      _this.$message.error("出了一点问题")
    })
    //    获取当前用户
    userInfo.base().then(v => {
      this.userName = v.data.userName;
    })
  },
  methods: {
    //下载模板
    download: function (e) {
      var url = process.env.VUE_APP_API;
      url += "/store/downloadExcel";
      location.href = url;
    },
    cancle: function () {
      this.$router.push(this.adminPath + "/system/store")
    },
    // 上一步
    preStep() {
      let stepLen = this.stepValue.length
      let cur = this.currentStep
      if (cur <= 0) {
        // 结束操作
        return
      }
      if (cur > -1 && cur < stepLen) {
        this.$set(this.stepValue[cur], "active", false)
      }

      this.$set(this.stepValue[cur - 1], "complete", false)
      this.currentStep--

    },
    nextStep: function (type) {
      var _this = this;
      //    上传完成
      var obj = {
        path: "",
        storeId: this.storeId,
      }
      if (!this.files[0] || !this.files[0].url) {
        this.$message.warning("请上传文件");
        return;
      } else {
        obj.path = this.files[0].url;
      }

      //初次上传
      if (type == 0) {
        if (!obj.storeId) {
          this.$message.warning("请选择门店");
          return;
        } else {
          var id = obj.storeId;
          var option = document.getElementById(id);
          var html = option.innerText;
          this.storeName = html;
        }
        var date = new Date();
        this.dateTime = this.$dateFormat(date);
        uploadExcelDevice(obj).then(function (success) {
          _this.list = success.data;
          _this.nextArrow();
        }).catch(function ([error, res]) {

            _this.nextArrow();
            _this.nextArrow();
            _this.currentStep++;

          if (res && res.code == -101 && res.data) {
            _this.fail = res.data.url;
          }
        })
      }

      //确认上传
      if (type == 1) {
        uploadExcelDeviceSure(obj).then(function (success) {
          _this.nextArrow();
        })
      }
    },
    nextArrow: function () {
      let stepLen = this.stepValue.length;
      let cur = this.currentStep;
      if (cur >= stepLen) {
        // 结束操作
        return;
      }
      if (cur < stepLen - 1) {
        this.$set(this.stepValue[cur + 1], "active", true);
      }

      this.$set(this.stepValue[cur], "complete", true);
      this.currentStep++;
    },
    finish: function () {
        parent.window.store.initData();
        this.close();
      // this.$router.push(this.adminPath + "/system/store");
    },
    //    重新上传
    reUpload: function () {
      location.href = "";
    },
    close: function () {
        parent.window.store=null;
        parent.myLayer.close(this.index);
    },
  },
  async mounted() {
    await myLayerImport();
    this.index = parent.myLayer.getFrameIndex(window.name);
  },
}
</script>

<style scoped lang="scss">
.action {
  height: 32px;
  background-color: #ffffff;
  border-radius: 8px;
  border: solid 1px #cfd5e0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #507dde;
  padding: 0 10px;
  cursor: pointer;
  img {
    margin-right: 3px;
  }
}
.complete {
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
  .result {
    margin-top: 61px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tips {
      font-size: 18px;
      color: #6e7a90;
      line-height: 18px;
      margin: 12px 0;
    }
    .xc-info-content {
      font-size: 14px;
      color: #b6bcc7;
      .xc-info-row {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
